import { GQL_ID } from '@@partner:types:graphql'
import { gql, useMutation } from '@apollo/client'

type RequireAtLeastOne<T, Keys extends keyof T = keyof T> =
    Pick<T, Exclude<keyof T, Keys>> 
    & {
        [K in Keys]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<Keys, K>>>
    }[Keys]

export interface GenerateSlotsBaseInput {
  zone_id?: GQL_ID
  shop_id?: GQL_ID
  replaceCreated?: boolean
}

export type GenerateSlotsVariables = RequireAtLeastOne<GenerateSlotsBaseInput, 'shop_id' | 'zone_id'>

export type GenerateSlotsInfo = boolean

export const GQL_MUTATION_GENERATE_SLOTS = gql`
  mutation generateSlots ($zone_id: ID, $shop_id: ID, $replaceCreated: Boolean) {
    generateSlots(zone_id: $zone_id, shop_id: $shop_id, replaceCreated: $replaceCreated)
  }
`

export const useMutateGenerateSlots = () => useMutation<GenerateSlotsInfo, GenerateSlotsVariables>(GQL_MUTATION_GENERATE_SLOTS)